<template>
  <div class="page-wrap">
    <!-- Header -->
    <header class="header">
      <div>
        <h1 class="title">电池数据总监控</h1>
        <p class="subtitle">实时监控全量电动车电池运行状态与健康度</p>
      </div>
      <div class="filters">
        <!-- <el-select v-model="filters.type" placeholder="电池类型" clearable size="small">
          <el-option label="全部类型" value="all" />
          <el-option label="磷酸铁锂" value="LFP" />
          <el-option label="三元锂电" value="NMC" />
        </el-select> -->
        <div class="filters-carrier">
          <span class="carrier-label">{{ $t('g.operator') }}</span>
          <el-cascader   :clearable="true" v-model="CodePathID"
            :props="props" :options="cascade_options_direct" @change="OperatorChange" />
        </div>
        <!-- <el-select v-model="filters.volts" placeholder="电压规格" clearable size="small">
          <el-option label="全部规格" value="all" />
          <el-option label="48V" value="48V" />
          <el-option label="60V" value="60V" />
          <el-option label="72V" value="72V" />
        </el-select> -->
        <!-- <el-input v-model="searchQuery" placeholder="搜索电池编号..." clearable size="small" style="width:220px" /> -->
        <!-- <el-button type="primary" size="small" @click="refreshData">刷新数据</el-button> -->
      </div>
    </header>

    <!-- Top cards -->
    <section class="cards">
      <div class="card">
        <div>
          <p class="muted">总电池数量</p>
          <h3 class="big">{{ totalData.BatStatus?.Normal+ totalData.BatStatus?.Abnormal}}</h3>
        </div>
        <div class="icon bg-blue">🔋</div>
      </div>
      <div class="card">
        <div>
          <p class="muted">正常电池数</p>
          <h3 class="big">{{ totalData.BatStatus?.Normal }}</h3>
        </div>
        <div class="icon bg-green">✔️</div>
      </div>
      <div class="card">
        <div>
          <p class="muted">异常电池数</p>
          <h3 class="big danger">{{  totalData.BatStatus?.Abnormal }}</h3>
        </div>
        <div class="icon bg-red">⚠️</div>
      </div>
      <div class="card">
        <div>
          <p class="muted">平均健康度 SOH</p>
          <h3 class="big">{{totalData.BatSOHGroup?.AvgSoh}}%</h3>
        </div>
        <div class="icon bg-amber">⚡</div>
      </div>
    </section>

    <!-- Charts -->
    <section class="charts">
      <div class="chart-card">
        <h4>SOH 健康度分布</h4>
        <div ref="sohChart" class="chart-area"></div>
      </div>
      <div class="chart-card">
        <h4>电池状态占比</h4>
        <div ref="statusChart" class="chart-area"></div>
      </div>
      <div class="chart-card">
        <h4>充电次数分布统计</h4>
        <div ref="cycleChart" class="chart-area"></div>
      </div>
    </section>

    <!-- Online/Offline chart below the three charts -->
    <!-- <section class="charts-bottom">
      <div class="chart-card">
        <h4>电池离线占比</h4>
        <div ref="onlineChart" class="chart-area"></div>
      </div>
    </section> -->

    <!-- Table -->
    <section class="table-card">
      <div class="table-header">
        <h4>电池列表明细</h4>
      </div>
      <el-table ref="dataTable" :data="batteryData" stripe  @row-click="openDrawer">
        <el-table-column prop="DevId" label="电池编号" width="180" />
        <!-- <el-table-column prop="type" label="电池类型" width="100" /> -->
        <el-table-column label="电压规格" width="100">
          <template #default="{row}">
            <div>
              {{  row.Volt/10  }}V
            </div>
          </template>
        </el-table-column>
        <el-table-column label="当前电量" width="200">
          <template #default="{ row }">
            <div class="soc-cell">
              <div class="soc-bar"><div :class="['soc-fill', row.socValue < 20 ? 'low' : 'normal']" :style="{ width: row.Soc*1.2 + 'px' }"></div></div>
              <span class="soc-text">{{ row.Soc }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Soh" label="健康度 SOH" />
        <el-table-column prop="ChargeCount" label="循环次数"/>
        <el-table-column label="状态">
          <template #default="{ row }">
            <el-tag :type="row.Error == 0 ? 'success' : 'danger'">

              {{ row.Error == 0?'正常':'异常'}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" >
          <template #default="{ row }">
            <el-button  size="small" @click.stop="openDrawer(row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="table-footer">
        <div class="info">显示 {{ startRecord }} 到 {{ endRecord }} 条，共 {{ total }} 条</div>
        <el-pagination background layout="prev, pager, next" :page-size="pageSize" v-model:current-page="currentPage" :total="total" @current-change="onPageChange" />
      </div>
    </section>

    <!-- Drawer -->
    <el-drawer v-model="drawerVisible" title="电池详情" size="40%">
      <div v-if="selected" class="drawer-content">
        <div class="section">
          <div class="section-header">
            <div class="section-marker marker-primary"></div>
            <h4 class="section-title">电池基础信息</h4>
          </div>
          <div class="section-grid">
            <div class="info-card">
              <p class="info-small">电池类型</p>
              <!-- {{ selected.type || '磷酸铁锂 (LFP)' }} -->
              <p class="info-strong"></p>
            </div>
            <div class="info-card">
              <p class="info-small">规格</p>
              <p class="info-strong">{{ selected.Volt/10 || '60V / 20Ah' }}V</p>
            </div>
            <div class="info-card">
              <p class="info-small">创建日期</p>
              <p class="info-strong">{{ selected.CreateAtStr || '2023-05-12' }}</p>
            </div>
            <div class="info-card">
              <p class="info-small">累计使用</p>
              <p class="info-strong">{{ selected.difference || '482 天' }}</p>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section-header">
            <div class="section-marker marker-emerald"></div>
            <h4 class="section-title">当前实时状态</h4>
          </div>
          <div class="status-list">
            <div class="status-row">
              <div class="status-left">
                <div class="status-icon bg-blue">
                  <span class="icon-emoji">⚡</span>
                </div>
                <div>
                  <p class="info-small">当前剩余电量</p>
                  <p class="info-strong">{{ selected.Soc}}%</p>
                </div>
              </div>
              <div class="status-right">
                <p class="info-small">估算续航</p>
                <p class="info-strong">{{ selected.range || '54.2 km' }}</p>
              </div>
            </div>

            <div class="status-row">
              <div class="status-left">
                <div class="status-icon bg-amber">
                  <span class="icon-emoji">🌡️</span>
                </div>
                <div>
                  <p class="info-small">实时工作温度</p>
                  <p class="info-strong">{{ selected.CellTemp}}°C</p>
                </div>
              </div>
              <div class="status-right small-pill">温度正常</div>
            </div>

            <div class="diagnosis-card">
              <div class="diag-left">
                <p class="info-small">诊断状态</p>
                <p class="diag-title">{{ selected.diagnosis || '运行状态良好' }}</p>
              </div>
              <div class="diag-icon">
                <div class="diag-circle">✔️</div>
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section-header">
            <div class="section-marker marker-amber"></div>
            <h4 class="section-title">寿命核心数据</h4>
          </div>
          <div class="life-card">
            <div class="life-top">
              <div>
                <p class="info-small life-label">健康度 SOH</p>
                <div class="life-soh">{{ selected.Soh }}%</div>
              </div>
              <div class="life-right">
                <p class="info-small">总循环次数</p>
                <p class="info-strong">{{ selected.cycles || '284 次' }}</p>
              </div>
            </div>
            <div class="life-rows">
              <div class="life-row"><span>当前容量</span><span class="info-strong">{{ selected.Energy / 100}}Ah</span></div>
              <div class="life-row"><span>额定容量</span><span class="info-strong">{{ selected.ratedCapacity || '20.0 Ah' }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onBeforeUnmount, nextTick, watch } from 'vue'
import { cascade_options_direct } from "@/data/default";
import * as echarts from 'echarts'
import axios from "axios";
import { toDay } from "@/common/func";
import i18n from "@/data/i18n/index";
const t = i18n.global.t;
const filters = reactive({ type: 'all', volts: 'all' })
const searchQuery = ref('')
const batteryData = ref([])
let props = ref(
  {
    children: "Children",
    label: "Name",
    value: "Id",
    emitPath: false,
    checkStrictly: true
  }
) 
let CodePathID = ref('')
let curPage = ref(1)
let total = ref(10)
let pageSize = ref(10)
let currentPage = ref(1)
async function loadData(page = 1) {
  try {
    batteryData.value = [];
    currentPage.value = page;
    let params = {
      page,
    };

    if (CodePathID.value) {
      params.CodePathID = CodePathID.value;
    }
    let res = await axios.get(`/admin/battery`, {
      params,
    });
    console.log(res, '列表数据')
    total.value = res.Total;
    const timestamp = new Date().getTime() / 1000;
    const oneDay = 24 * 60 * 60; // 一天的秒数
    res.List.map((item) => {
      item.CreateAtStr = toDay(item.CreateAt);
      item.UpdateAtStr = toDay(item.UpdateAt);
      item.difference = Math.floor(( timestamp - item.CreateAt) / oneDay);
      console.log(timestamp - item.CreateAt)
      item.InDevUpdateAtStr = toDay(item.InDevUpdateAt);
      item.BatUpdateAtStr = item.BatUpdateAt != 0 ? toDay(item.BatUpdateAt) : t("g.null");
      item.BatUpdateAtStr = item.BatUpdateAt != 0 ? toDay(item.BatUpdateAt) : t("g.null");
      item.socValue = parseInt(item.Soc)
    });
    batteryData.value = res.List;
    pageSize.value = res.PageSize;
    console.log(batteryData.value,'222222')
    // 更新在线/离线等基于列表计算的图表
    updateCharts()
  } catch (e) {
    console.log("loadData", e);
  }
}
let totalData = ref({})
async function getData() {
  let params = {
    CodePathID:CodePathID.value
  }
  let res = await axios.get(`/admin/batanalysis/batoverview`, {
    params,
  });
  totalData.value = res
  // 更新基于 totalData 的图表
  updateCharts()
}


const startRecord = computed(() => (total.value === 0 ? 0 : (currentPage.value - 1) * pageSize.value + 1))
const endRecord = computed(() => Math.min(currentPage.value * pageSize.value, total.value))

function onPageChange(page) {
   currentPage.value = page
   loadData(page);
}
async function refreshData() { 
  await loadData()
  await getData()
}

async function OperatorChange() {
  total.value = 10
  pageSize.value = 10
  currentPage.value = 1
  await loadData()
  await getData()
  console.log('切换',CodePathID.value)
}

const drawerVisible = ref(false)
const selected = ref(null)
function openDrawer(row) {
  console.log('打开',row)
  selected.value = row;
  drawerVisible.value = true 
}

// Charts
const sohChart = ref(null)
const statusChart = ref(null)
const cycleChart = ref(null)
const onlineChart = ref(null)
const dataTable = ref(null)
let sohInstance = null
let statusInstance = null
let cycleInstance = null
let onlineInstance = null

function initCharts() {
  try {
    if (sohChart.value) {
      sohInstance = echarts.init(sohChart.value)
      sohInstance.setOption({
        tooltip: { trigger: 'item' },
        legend: { bottom: 12, textStyle: { fontSize: 12 }, itemGap: 12 },
        series: [{ type: 'pie', radius: ['50%', '70%'], avoidLabelOverlap: false, label: { show: false }, data: [
          { value: totalData.value.BatSOHGroup.Thrity, name: '0-60%', itemStyle: { color: '#EF4444' } },
          { value: totalData.value.BatSOHGroup.Sixty, name: '60-80%', itemStyle: { color: '#F59E0B' } },
          { value: totalData.value.BatSOHGroup.Eighty, name: '80-100%', itemStyle: { color: '#10B981' } }
        ]}]
      })
    }

    if (statusChart.value) {
      statusInstance = echarts.init(statusChart.value)
      statusInstance.setOption({
        tooltip: { trigger: 'item' },
        legend: { show: false },
        series: [{ type: 'pie', radius: '70%', label: { show: true, formatter: '{b}: {d}%' , fontSize:12 }, data: [
          { value: totalData.value.BatStatus?.Normal, name: '正常', itemStyle: { color: '#10B981' } },
          { value: totalData.value.BatStatus?.Abnormal, name: '异常', itemStyle: { color: '#EF4444' } },
        ]}]
      })
    }

    if (cycleChart.value) {
      cycleInstance = echarts.init(cycleChart.value)
      cycleInstance.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 48, right: 16, bottom: 40, top: 24 },
        xAxis: { type: 'category', data: ['0-100', '100-300', '300-500', '500+'], axisLabel: { rotate: 0, fontSize: 13 } },
        yAxis: { type: 'value', axisLabel: { fontSize: 13 } },
        series: [{ data: [totalData.value.BatChargingTimes.OneHundred, totalData.value.BatChargingTimes.ThreeHundreds, totalData.value.BatChargingTimes.FireHundreds, totalData.value.BatChargingTimes.MoreThanfireHundreds], type: 'bar', itemStyle: { color: '#0F52FF' }, barWidth: '36%' }]
      })
    }
    
    // online/offline pie (new chart)
    if (onlineChart.value) {
      const onlineCount = batteryData.value.filter(i=>i.status==='正常').length
      const offlineCount = batteryData.value.length - onlineCount
      onlineInstance = echarts.init(onlineChart.value)
      onlineInstance.setOption({
        tooltip: { trigger: 'item' },
        legend: { bottom: 6, textStyle: { fontSize: 12 } },
        series: [{ type: 'pie', radius: ['50%', '70%'], label: { show: false }, data: [
          { value: onlineCount, name: '在线', itemStyle: { color: '#10B981' } },
          { value: offlineCount, name: '离线', itemStyle: { color: '#EF4444' } }
        ]}]
      })
    }
  } catch (e) { console.warn('echarts init error', e) }
}

// update existing chart instances with fresh data
function updateCharts() {
  try {
    if (sohInstance) {
      sohInstance.setOption({
        series: [{ data: [
          { value: totalData.value.BatSOHGroup?.Thrity || 0, name: '0-60%', itemStyle: { color: '#EF4444' } },
          { value: totalData.value.BatSOHGroup?.Sixty || 0, name: '60-80%', itemStyle: { color: '#F59E0B' } },
          { value: totalData.value.BatSOHGroup?.Eighty || 0, name: '80-100%', itemStyle: { color: '#10B981' } }
        ]}]
      })
    }

    if (statusInstance) {
      statusInstance.setOption({
        series: [{ data: [
          { value: totalData.value.BatStatus?.Normal || 0, name: '正常', itemStyle: { color: '#10B981' } },
          { value: totalData.value.BatStatus?.Abnormal || 0, name: '异常', itemStyle: { color: '#EF4444' } }
        ]}]
      })
    }

    if (cycleInstance) {
      cycleInstance.setOption({
        series: [{ data: [
          totalData.value.BatChargingTimes?.OneHundred || 0,
          totalData.value.BatChargingTimes?.ThreeHundreds || 0,
          totalData.value.BatChargingTimes?.FireHundreds || 0,
          totalData.value.BatChargingTimes?.MoreThanfireHundreds || 0
        ]}]
      })
    }

    if (onlineInstance) {
      const onlineCount = batteryData.value.filter(i=>i.status==='正常').length
      const offlineCount = batteryData.value.length - onlineCount
      onlineInstance.setOption({
        series: [{ data: [
          { value: onlineCount, name: '在线', itemStyle: { color: '#10B981' } },
          { value: offlineCount, name: '离线', itemStyle: { color: '#EF4444' } }
        ]}]
      })
    }
  } catch (e) { console.warn('updateCharts error', e) }
}

onMounted(async () => {
  await loadData()
  await getData()
  nextTick(() => {
    initCharts()
    window.addEventListener('resize', resizeCharts)
    // ensure table layout after initial render
    nextTick(() => { dataTable.value && dataTable.value.doLayout && dataTable.value.doLayout() })
  })
})

// re-layout table when data or page changes
// watch([filteredData, currentPage], () => {
//   nextTick(() => { dataTable.value && dataTable.value.doLayout && dataTable.value.doLayout() })
// })

onBeforeUnmount(() => {
  window.removeEventListener('resize', resizeCharts)
  sohInstance && sohInstance.dispose()
  statusInstance && statusInstance.dispose()
  cycleInstance && cycleInstance.dispose()
  onlineInstance && onlineInstance.dispose()
})

function resizeCharts() {
  sohInstance && sohInstance.resize()
  statusInstance && statusInstance.resize()
  cycleInstance && cycleInstance.resize()
  onlineInstance && onlineInstance.resize()
}
</script>

<style scoped>
.page-wrap {
    padding: 22px;
    background: #F1F5F9;
    min-height: 100%;
}
.header {
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:12px;
    margin-bottom:20px ;
}
.title { 
    margin:0;
    font-size:22px;
    font-weight:700;
    color:#0f1724;
}
.subtitle {
    margin:0; color:#6b7280; font-size:14px;
}
.filters {
    display:flex;
    gap:10px;
    align-items:center;
}
.cards {
    display:grid;
    grid-template-columns:repeat(4,1fr);
    gap:12px;
    margin-bottom:18px;
}
.card {
    background:#fff;
    padding:16px;
    border-radius:12px;
    display:flex;
    justify-content:space-between;
    align-items:center;
    box-shadow:0 1px 2px rgba(16,24,40,0.04);
}
.muted { 
    color:#6b7280;
    font-size:12px;
    margin:0;
}
.big {
    margin:0;
    font-size:22px;
    font-weight:800;
}
.danger {
    color:#ef4444;
}
.icon { 
    width:44px;
    height:44px;
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:10px;
    font-size:18px;
}
.bg-blue { 
    background:#eff6ff;
    color:#0f52ff;
}
.bg-green {
    background:#ecfdf5;
    color:#10b981;
}
.bg-red {
    background:#fff1f2;
    color:#ef4444;
}
.bg-amber { 
    background:#fffbeb;
    color:#f59e0b; 
}
.charts {
    display:grid;
    grid-template-columns:repeat(3,1fr);
    gap:12px;
    margin-bottom:18px;
}
.chart-card {
    background:#fff;
    padding:14px;
    border-radius:12px;
}
.chart-area {
    height:240px;
}
.chart-card {
    background:#fff;
    padding:18px 14px 28px;
    border-radius:12px;
    display:flex;
    flex-direction:column;
}
.charts-bottom { 
    margin-top:12px;
    margin-bottom:18px;
}
.table-card { 
    background:#fff;
    border-radius:12px;
    padding:12px;
}
.table-header { 
    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-bottom:8px;
}
.table-footer { 
    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-top:10px;
}
.info { 
    color:#6b7280;
    font-size:12px;
}
.soc-cell { 
    display:flex;
    align-items:center;
    gap:8px;
}
.soc-bar {
    width:120px;
    height:8px;
    background:#f1f5f9;
    border-radius:8px;
    overflow:hidden;
}
.soc-fill {
    height:100%;
    border-radius:8px;
}
.soc-fill.normal {
    background:#0f52ff; 
    }
.soc-fill.low {
    background:#ef4444; 
    }
.soc-text {
    font-size:12px;
    color:#374151;
}
.drawer-grid {
    display:grid;
    grid-template-columns:repeat(2,1fr);
    gap:12px;
    margin-top:12px;
}
.info-box {
    background:#f8fafc;
    padding:12px;
    border-radius:8px;
}
.label {
    color:#6b7280;
    font-size:12px;
    margin:0;
}
.value { 
    font-weight:700;
    margin-top:6px;
}

.drawer-content {
    padding: 24px;
}
.section {
    margin-bottom: 20px;
}
.section-header {
    display:flex;
    align-items:center;
    gap:8px;
    margin-bottom:12px;
}
.section-marker { 
    width:4px;
    height:20px;
    border-radius:2px;
}
.marker-primary {
     background:#0F52FF;
    }
.marker-emerald {
     background:#10B981; 
    }
.marker-amber { 
    background:#F59E0B; 
}
.section-title { 
    margin:0;
    font-size:16px;
    font-weight:700;
    color:#0f1724;
}
.section-grid {
    display:grid;
    grid-template-columns:repeat(2,1fr);
    gap:12px; 
}
.info-card { 
    background:#f8fafc;
    padding:12px;
    border-radius:10px;
}
.info-small {
    font-size:11px;
    color:#6b7280; 
    text-transform:uppercase;
    letter-spacing:0.6px;
    margin:0; 
}
.info-strong { 
    font-weight:700;
    color:#0f1724;
    margin-top:6px;
}

.status-list { 
    display:flex;
    flex-direction:column;
    gap:12px;
}
.status-row {
    display:flex; 
    justify-content:space-between;
    align-items:center;
    padding:12px;
    border:1px solid #eef2f6;
    border-radius:12px;
    background:#fff; 
}
.status-left { 
    display:flex;
    align-items:center;
    gap:12px;
}
.status-icon {
    width:40px;
    height:40px;
    border-radius:10px;
    display:flex; 
    align-items:center; 
    justify-content:center;
}
.bg-blue { 
    background:#eff6ff ;
}
.bg-amber {
     background:#fff7ed ;
    }
.icon-emoji {
     font-size:18px;
     }
.status-right { 
    text-align:right ;
}
.small-pill {
    background: rgba(16,185,129,0.08);
    color:#10B981;
    padding:6px 8px; 
    border-radius:12px;
    font-weight:700;
    font-size:12px;
}

.diagnosis-card { 
    background:#0f1724;
    color:#fff;
    padding:16px; 
    border-radius:14px;
    display:flex; 
    justify-content:space-between;
    align-items:center;
}
.diag-left .info-small {
     color: rgba(255,255,255,0.7);
}
.diag-title { 
    font-size:18px;
    font-weight:800;
    margin-top:6px; 
}
.diag-icon .diag-circle { 
    width:48px;
    height:48px; 
    border-radius:50%;
    background:rgba(255,255,255,0.08);
    display:flex; 
    align-items:center;
    justify-content:center;
    font-size:18px;
}
.life-card { 
    background: linear-gradient(180deg, rgba(255,249,236,0.5), rgba(255,249,236,0.3));
    border:1px solid rgba(245,158,11,0.12);
    padding:16px;
    border-radius:14px
}
.life-top {
    display:flex;
    justify-content:space-between; 
    align-items:flex-end;
    margin-bottom:12px 
}
.life-label { 
    color:#b45309
 }
.life-soh { 
    font-size:28px;
    font-weight:900;
    color:#0f1724; 
}
.life-right { 
    text-align:right;
}
.life-rows { 
    border-top:1px dashed rgba(245,158,11,0.18); 
    padding-top:12px;
    display:flex; 
    flex-direction:column;
    gap:8px; 
}
.life-row { 
    display:flex;
    justify-content:space-between;
    align-items:center;
}

/* Make element table font and padding more consistent */
::v-deep .el-table th, ::v-deep .el-table td { font-size:13px; padding: 10px 12px; }
::v-deep .el-table th { color: #4b5563; font-weight:600 }

@media (max-width: 900px) {
  .charts { grid-template-columns:1fr }
  .cards { grid-template-columns:repeat(2,1fr) }
}
.carrier-label{
  font-size: 16px;
  margin-right: 18px;
}
.filters-carrier{
  display: flex;
  align-items: center;
}
</style>